import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import GrayButton from '~/components/traffic-tickets/steps/GrayButton'

import STYLE_CONSTANTS from '~/style/constants'

const Main = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  padding-top: .5rem;
  width: 100%;
  ${props => props.theme.media.mobile`
    flex-direction: column;
    align-items: flex-start;
  `}
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  font-family: ${props => props.theme.fonts.avenirNextRegular};
  font-size: 0.9rem;
  margin-bottom: 5px;
  color: ${STYLE_CONSTANTS.colors.text.pronouncedGray};
`

const ButtonHolder = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  padding-right: 9px;
  ${props => props.theme.media.smallDesktop`
  `}
`

const AddressItemComponent = ({ address, city, countryState, zipcode, addHandler }) => {
  return (
    <Main>
      <Container>
        <div>{address}</div>
        <div>
          {city}
          ,&nbsp;
          {countryState}
          &nbsp;
          {zipcode}
        </div>
      </Container>
      <ButtonHolder>
        <GrayButton onClick={addHandler}>
          Change Address
        </GrayButton>
      </ButtonHolder>
    </Main>
  )
}

AddressItemComponent.defaultProps = {
  address: null,
  city: null,
  countryState: null,
  zipcode: null
}

AddressItemComponent.propTypes = {
  address: PropTypes.string,
  city: PropTypes.string,
  countryState: PropTypes.string,
  zipcode: PropTypes.string
}

export default AddressItemComponent
